import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

const TermsOfService = () => {
  const { language } = useLanguage();
  const t = translations[language].legal.terms;

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            {t.title}
          </h1>
          <p className="text-muted-foreground">
            {t.lastUpdated}: 23 oktober 2025
          </p>
        </div>

        <div className="space-y-8 text-foreground">
          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.intro.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.intro.content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.bookings.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {t.bookings.content}
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground ml-4">
              {t.bookings.items.map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.age.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {t.age.content}
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground ml-4">
              {t.age.items.map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.health.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {t.health.content}
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground ml-4">
              {t.health.items.map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.safety.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {t.safety.content}
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground ml-4">
              {t.safety.items.map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.liability.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.liability.content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-primary">{t.law.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.law.content}
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-cyan via-purple to-pink text-white font-semibold rounded-lg hover:opacity-90 transition-opacity"
          >
            {t.backToHome}
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService;
